<div class="addon-page">
  <div
    class="empty-state"
    *ngIf="banners && banners.banners?.length === 0"
  >
    <mat-icon class="empty-state__icon">image</mat-icon>
    <p>{{ "addons.banners.empty" | translate }}</p>
  </div>

  <div class="content" *ngIf="banners && banners.banners?.length > 0">
    <div *ngFor="let banner of banners.banners">
      <app-banner [banner]="banner"></app-banner>
    </div>
  </div>

  <div class="dbc1-loading dbc1-loading--overlay" *ngIf="!banners">
    <app-loading></app-loading>
  </div>
</div>
